import classNames from 'classnames';
import { HTMLAttributes } from 'react';

import style from './caret.module.css';

type CaretDirection = 'down' | 'left' | 'right' | 'up';

interface CaretStyleProps {
  direction?: CaretDirection;
}
type HtmlSvgProps = HTMLAttributes<SVGElement>;

export type CaretProps = CaretStyleProps & HtmlSvgProps;

const defaultCaretDirection: CaretDirection = 'right';

const directionMap: Record<CaretDirection, string> = {
  down: style.caretDown,
  left: style.caretLeft,
  right: '', // No style needed for right
  up: style.caretUp,
};

const Caret = ({
  direction = defaultCaretDirection,
  ...htmlSvgProps
}: CaretProps) => {
  return (
    <svg
      className={classNames(
        directionMap[direction],
        htmlSvgProps.className,
      )}
      fill="none"
      height="12"
      viewBox="0 0 6 12"
      width="6"
      xmlns="http://www.w3.org/2000/svg"
      {...htmlSvgProps}
    >
      <path
        d="M3.43207 5.91071L0 9.34929L0.00349854 12L6 5.99825L0.00699708 0V2.48264L3.43207 5.91071Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Caret;
